import img2 from "../assets/images/home/home1.jpeg";
import img3 from "../assets/images/home/home2.jpeg";
import img4 from "../assets/images/home/home3.jpeg";
import { Link } from "react-router-dom";
import "../assets/css/TourSection.css";

function TourSection() {
  const tours = [
    {
      id: 2,
      title: "तीर्थसारथी – Spiritual Tours in India",
      category: "tirthsarthi",
      subtitle: "",
      points: [
        "तीर्थसारथी focuses on spiritual journeys and yatras, including Char Dham Yatra and temple दर्शन.",
        "Special facilities for senior citizens",
        "Well-organized and peaceful travel",
        "Experienced tour leaders",
      ],
      image: img2,
      reverse: true,
      bg: "#f9f9f9",
    },
    {
      id: 3,
      title: "Gypsy Club – Group Tours & Trips",
      category: "gypsy-club",
      subtitle: "",
      points: [
        "Gypsy Club is designed for fun and group travel experiences.",
        "Friends trips and camps",
        "Kashmir and offbeat destinations",
        "Comfortable stays and group activities",
      ],
      image: img3,
      reverse: false,
      bg: "",
    },
    {
      id: 4,
      title: "Gypsy Wildlife – Safari & Nature Tours",
      category: "gypsy-wildlife",
      subtitle: "",
      points: [
        "Gypsy Wildlife offers thrilling jungle safaris and nature tours.",
        "Tiger safaris in Tadoba and other reserves",
        "Open jeep safari experience",
        "Wildlife photography tours",
      ],
      image: img4,
      reverse: true,
      bg: "#f9f9f9",
    },
  ];

  const TourContent = ({ tour }) => (
    <div className="col-md-6">
      <div className="heading-39101 mb-4">
        <h3>{tour.title}</h3>
      </div>

      <ul style={{ marginBottom: "25px", lineHeight: "1.7" }}>
        {tour.points.map((point, index) => (
          <li key={index}>{point}</li>
        ))}
      </ul>

  <div className="text-center text-md-start">
  <Link 
    to={`/tour?category=${tour.category}`} 
    className="btn btn-about py-2 px-3 mb-5"
  >
    Read More
  </Link>
</div>
    </div>
  );

  const TourImage = ({ tour }) => (
    <div className="col-md-6">
      <div className="img-wrap">
        <Link to={`/tour?category=${tour.category}`} className="effect">
          <img
            src={tour.image}
            alt={tour.title}
            className="img-fluid"
            style={{
              width: "500px",

              display: "block",
              borderRadius: "0 30px 0 30px"
            }}
          />
        </Link>
      </div>
    </div>
  );

  return (
    <>
      {tours.map((tour) => (
        <div
          key={tour.id}
          className="site-section py-5"
          style={{ backgroundColor: tour.bg }}
        >
          <div className="container">
            <div className="row align-items-center">
              {!tour.reverse ? (
                <>
                  <TourContent tour={tour} />
                  <TourImage tour={tour} />
                </>
              ) : (
                <>
                  <TourImage tour={tour} />
                  <TourContent tour={tour} />
                </>
              )}
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default TourSection;